export default __webpack_public_path__ + "static/media/usdc-logo.f08e02b1.svg";